'use strict';

export default function (url) {
  let array = ['facebook', 'linkedin', 'twitter', 'youtube', 'instagram'];
  return _.head(_.filter(array, item => _.includes(url, item+'.com')));
}



// WEBPACK FOOTER //
// ./src/common/filters/social-type.js